import AOS from "aos";
import "aos/dist/aos.css";

// Animate on scroll
function animateOnScroll() {
  AOS.init({
    delay: 100,
    duration: 600,
    easing: "ease-out",
  });
}

export { animateOnScroll };
